import st from './RussiaMap.module.scss'
import {Link} from 'react-router-dom';
import {createPortal} from 'react-dom';
import {useScreenSize} from '../../helpers';

export const Tooltip = ({ popupRef, region, setSelect }) => {
    const { isMobile } = useScreenSize()
    return createPortal(
        <div
            ref={popupRef}
            className={st.tooltip}
        >
            <div>{region?.name}</div>

            {region?.representative === 1 &&
                <Link to={`/representative/${region?.id}`} onClick={()=> setSelect(null)}>
                    <span>Подробнее</span>
                </Link>
            }
        </div>, isMobile ? document.querySelector('#russian-map') : document.body
    )
}
